import styled from "styled-components";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getAllProduct } from "../Api/Api";
import ProductCats from "../Categories/ProductCats";

import { RingLoader } from "react-spinners";

const Products = () => {
  const allProducts = useQuery({
    queryKey: ["get-all"],
    queryFn: getAllProduct,
  });

  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  useEffect(() => {
    setIsLoading(true);

    setTimeout(() => {
      // End the loading state
      setIsLoading(false);
    }, 5000);
  }, []);

  return (
    <div>
      {isLoading ? (
        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <RingLoader color="black" size={60} />
        </div>
      ) : (
        <Container>
          <Head>
            New Arrivals.{" "}
            <span style={{ color: "darkgray" }}>Available as seen</span>
          </Head>
          <ProductCats />
          <Holder>
            {allProducts?.data?.data.map((el: any) => (
              <Card>
                <Link
                  style={{ textDecoration: "none", color: "black" }}
                  to={`/details/${el?._id}`}
                >
                  <MainImage>
                    <ImageHold>
                      <Image src={el?.productImage} />
                    </ImageHold>
                    <Title>{el.title} </Title>
                    <p>
                      <span>Category: </span>
                      {el?.category}{" "}
                    </p>
                    {/* <Title>title </Title> */}
                    {/* <Desc>{el.desc} </Desc> */}
                    <Desc> </Desc>
                    <PriceHold>
                      <Price> ₦{el.price}</Price>
                      {/* <Price>$price</Price> */}
                      <Link
                        style={{ textDecoration: "none", color: "black" }}
                        to={`/details/${el?._id}`}
                      >
                        <Ratting>
                          {/* <AiFillStar
                        style={{
                          color: "gold",
                          marginRight: "10px",
                        }}
                      />
                      4.2(87 reviews) */}
                          Buy
                        </Ratting>
                      </Link>
                    </PriceHold>
                  </MainImage>
                </Link>
              </Card>
            ))}
          </Holder>
        </Container>
      )}
    </div>
  );
};

export default Products;

const Card = styled.div`
  margin: 10px;
`;
const ImageHold = styled.div`
  height: 250px;
  width: 250px;
  background-color: #f7f9fb;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Title = styled.div`
  font-weight: 700;
  margin-bottom: 20px;
  margin-top: 10px;
`;
const Desc = styled.div`
  color: gray;
  width: 250px;
  font-size: 13px;
  text-align: left;
`;
const PriceHold = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 5px;
  align-items: center;
`;
const Price = styled.div`
  height: 30px;
  width: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid green;
  font-weight: 600;
  color: green;
  border-radius: 5px;
  margin-bottom: 10px;
`;
const Ratting = styled.button`
  border-radius: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 30px;
  background-color: black;
  color: white;
  cursor: pointer;
  font-weight: bold;
  transition: all ease-in-out 400ms;
  margin-bottom: 20px;
  border-radius: 5px;
  border: 1px solid black;
  transition: all 400ms ease-in-out;
  :hover {
    background-color: #0000005c;
    transform: scale(0.99);
  }
`;
const MainImage = styled.div``;
const Image = styled.img`
  width: 200px;
  height: 200px;
  border-radius: 10px;
`;

const Holder = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding-bottom: 70px;
  justify-content: space-between;
`;

const Head = styled.div`
  font-size: 30px;
  margin-bottom: 10px;
  font-weight: 600;
`;

const Container = styled.div`
  margin-top: 100px;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding-left: 50px;
  overflow: hidden;
  margin-bottom: 50px;
  border-bottom: 1px solid silver;
`;
